import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetLocationsPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/inputs/get-locations-paginated.form-validation';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/inputs/get-locations-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { NetworkFilterController } from '@app/feature/network/network-filter/network-filter.controller';

const LocationListFilterFormStep1NetworkIdFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  const { control } = useFormContext<GetLocationsPaginatedModel>();
  const { networkId } = useGetLocationsPaginatedFormValidation();

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="networkId"
      control={control}
      rules={networkId}
      render={({ field }) => {
        const values = [];

        if (Array.isArray(field.value)) {
          values.push(...field.value);
        } else if (field.value) {
          values.push(field.value);
        }

        return (
          <NetworkFilterController
            selectedItemIds={values}
            onChange={(value) => field.onChange(value)}
          />
        );
      }}
    />
  );
};

export const LocationListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.M}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
        <LocationListFilterFormStep1NetworkIdFragment />
      </Stack>
    </Stack>
  );
};
